<template>
  <div class="page-head" v-if="title">
    <h1 v-if="title" v-text="title" />
    <span v-if="info" v-text="info" />
  </div>
</template>

<script>
export default {
  name: 'page-head',
  props: {
    title: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="scss">
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-bottom: 8px;
  word-wrap: break-word;
  max-width: 100%;

  & > h1 {
    max-width: 200px;
    font-size: 24px;
    line-height: 32px;
    font-weight: normal;
  }

  & > span {
    font-size: 12px;
    line-height: 16px;
    color: $gray_l;
  }
}

@include breakpoint("tablet") {
  .page-head {
    & > h1 {
      max-width: 100%;
    }
  }
}

@include breakpoint("desktop") {
  .page-head {
    margin-top: 40px;
    padding-bottom: 16px;
    border-bottom: 1px solid $gray_lu;

    & > h1 {
      font-size: 40px;
      line-height: 48px;
    }

    & > span {
      font-size: 14px;
      line-height: 20px;
    }
  }
}

</style>
